<template>
  <b-col md="3" sm="3" xl="3" class="text-center animated fadeIn fadeOut">
    <b-card :bg-variant="wmds.is_row == true ? 'warning' : 'success'" @click="detail(wmds)" :style="{ cursor: 'pointer'}">
      <!-- <h6><strong>{{item.name || '-'}}</strong></h6> -->
      <!-- <h6>{{item.host}}@{{item.ip_addr}}<br></h6> -->
      <!-- <b-badge variant="success" v-if="!item.ms == 0 ">Online ({{item.ms}} ms)</b-badge> -->
      <b-badge variant="light" style="min-width: 100px; max-width: 130px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{wmds.fqdn}}</b-badge>
    </b-card>
  </b-col>
</template>

<script>
export default {
  props: ['wmds'],
  methods: { detail: function(wmds) { this.$router.push({ name : 'wmds_site', params : { id : wmds.site_id } }); }, },
  created () { console.info('wmds-agent-item.vue created') },
  destroyed () { console.log('wmds-agent-item.vue destroyed') },
  mounted () {  console.log('wmds-agent-item.vue mounted'); setTimeout(this.$forceUpdate(), 3000)  },
}
</script>
